<script>
/** Type mighty be : default (or null), highlight, overlay**/
export default {
  props: ["click", "label", "href", "icon", "selected", "tooltip", "variant"],
  methods: {
    click_callback: function () {
      this.$emit("click");
      if (this.href) {
        window.location.href = this.href;
      }
    },
  },
};
</script>

<template>
  <f-simple-tooltip>
    <button
      class="keepfocus vfigma-list-item"
      :class="[variant, { selected }]"
      v-on:click="click_callback()"
    >
      <f-icon :icon="icon" class="vfigma-listitem-icon"></f-icon>
      <slot></slot>
    </button>
  </f-simple-tooltip>
</template>

<style lang="scss">
.vfigma-list-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  font-family: Lato;
  gap: 8px;
  background: none;
  color: rgba(255, 255, 255, 0.75);
  width: 64px;
  height: 88px;

  &:hover {
    color: rgba(255, 255, 255, 1);
    background: rgba(255, 255, 255, 0.1);
  }

  &:active {
    color: rgba(255, 255, 255, 1);
    background: rgba(24, 144, 211, 0.25);
  }

  &:active:hover {
    color: rgba(255, 255, 255, 1);
    background: rgba(255, 255, 255, 0.25);
  }

  &.selected {
    background: rgba(255, 255, 255, 0.1);
  }
}

.vfigma-list-item .vfigma-listitem-icon {
  font-size: 24px;
}

.vfigma-list-item:disabled {
  opacity: 0.25;
}

.vfigma-list-item.default {
  flex-direction: row;
  color: rgba(22, 22, 21, 0.75);
  padding: 12px;
  width: 100%;
  height: 100%;

  .vfigma-listitem-icon {
    color: rgba(24, 144, 211, 1);
    font-size: 18px;
  }

  &:active,
  &:active:hover {
    color: rgba(22, 22, 21, 1);
    background-color: rgba(24, 144, 211, 0.25);
  }

  &:hover {
    color: rgba(22, 22, 21, 1);
    background-color: rgba(24, 144, 211, 0.1);
  }
}

.vfigma-list-item.danger {
  color: rgba(208, 14, 14, 1);

  &:hover {
    color: rgba(208, 14, 14, 1);
    background-color: var(--statusNegative-a5);
  }

  &:active,
  &:active:hover {
    color: rgba(208, 14, 14, 1);
    background-color: var(--statusNegative-a10);
  }

  .vfigma-listitem-icon {
    color: rgba(208, 14, 14, 1);
  }
}

.vfigma-list-item.left {
  justify-content: left;
}

.dark-mode {
  .vfigma-list-item {
    color: var(--white-50);

    &:hover {
      background-color: var(--white-a10);
    }

    &:active {
      background-color: var(--white-a10);
    }

    &:active:hover {
      background-color: var(--white-a10);
    }

    &.selected {
      background-color: var(--white-a10);
	  font-weight:bold;
    }
  }

  .vfigma-list-item.default {
    color: var(--white-a75);

    .vfigma-listitem-icon {
      color: var(--primary);
    }

    &:active,
    &:active:hover {
      color: var(--white);
      background: var(--white-a5);
    }

    &:hover {
      color: var(--white);
      background: var(--white-a10);
    }
  }

  .vfigma-list-item.danger {
    color: var(--negative);

    &:hover {
      color: var(--negative);
      background-color: var(--negative-a5);
    }

    &:active,
    &:active:hover {
      color: var(--negative);
      background-color: var(--negative-a10);
    }

    .vfigma-listitem-icon {
      color: var(--negative);
    }
  }

  .vfigma-list-item.icon 
  {
    padding: 8px 16px 12px 16px;
  }
}
</style>